import { Route, Routes, BrowserRouter } from "react-router-dom";
import Home from 'pages/Home';
import Clim4CastLogPage from 'pages/Clim4CastLogPage';

function App() {
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/settings" element={<Home/>}/>
        <Route path="/_clim4cast_log" element={<Clim4CastLogPage/>}/>
      </Routes>
    </BrowserRouter>
  );

}

export default App; 
